import { withDependencies, type FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'

import type { ISdkStateDefinition } from '@wix/viewer-service-sdk-state/definition'
import { SdkStateDefinition as definition } from '@wix/viewer-service-sdk-state/definition'
import { SdkStateService as impl } from '@wix/viewer-service-sdk-state/implementations'

export const sdkStateService: FactoryWithDependencies<ServiceProvider<ISdkStateDefinition, typeof impl>> =
	withDependencies([], (): ServiceProvider<ISdkStateDefinition, typeof impl> => {
		return {
			definition,
			impl,
			config: {},
			platformConfig: {},
		}
	})
